<template>
    <m-dialog full-width :value="isModalOpened" @update:returnValue="closeDialog" class="pa-0">
        <template>
            <v-layout class="pa0">
                <v-flex  xs12 class="text-xs-right pa-0 ">
                    <e-button-close class="m-dialog__close mt-0" @click="closeDialog(false)"/>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                    <e-typography-heading-3>
                        {{$t('modules.dialogs.m-dialog-risk-assessment-create.title')}}
                    </e-typography-heading-3>
                </v-flex>
                <v-flex xs12 class="mt-4 text-xs-center">
                    <e-typography-body-small>
                        {{$t('modules.dialogs.m-dialog-risk-assessment-create.text')}}
                    </e-typography-body-small>
                </v-flex>
                <v-flex xs12>
                    <m-form-risk-assessment class="pa-0 m-dialog-risk-assessment__form" ref="form"/>
                </v-flex>
            </v-layout>
        </template>

        <template v-slot:actions>
            <v-layout>
                <v-flex class="text-xs-center">
                    <e-button-primary @click="createAssessment" :loading="$wait.waiting(keys.riskAssessments.create)">{{$t('modules.dialogs.m-dialog-risk-assessment-create.buttons.submit')}}</e-button-primary>
                </v-flex>
            </v-layout>
        </template>
    </m-dialog>
</template>

<script>
    import MDialog from "@components/modules/dialogs/m-dialog";
    import {mapActions, mapGetters} from 'vuex';
    import vuexKeys from "@mixins/includes/_vuexKeys";
    import MFormRiskAssessment from "@modules/forms/concrete/risk-assessment/m-form-risk-assessment";
    import notifications from "@mixins/includes/_notifications";

    export default {
        name: "m-dilalog-risk-assessment-create",
        inheritAttrs: false,
        components: {MFormRiskAssessment, MDialog},
        mixins: [vuexKeys, notifications],
        computed: {
            ...mapGetters({
                isOpened:'dialogs/isOpened',
                getPromises:'dialogs/getPromises'
            }),

            isModalOpened() {
                return this.isOpened(this.type);
            },
            type() {
                return 'riskAssessmentCreate';
            }
        },
        methods: {
            ...mapActions({
                close:'dialogs/close'
            }),
            closeDialog(result) {
                this.getPromises(this.type).resolve(result);
                this.$refs.form.clear();
                this.close(this.type);
            },
            async createAssessment(){
                try {
                    const assessmentId = await this.$refs.form.submit();
                    if(assessmentId){
                        this.closeDialog(assessmentId)
                    }
                } catch (e) {
                    this.notify.processUnhandledError(e)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .m-dialog-risk-assessment__form{
        /deep/ .m-form-content-template{
            margin-top: 1rem;
            margin-bottom: 0;
        }
    }
</style>
